import React from 'react';
import { Users, UserPlus } from 'lucide-react';
import { IconButton } from '../ui';
import { useNavigate } from 'react-router-dom';

const ConnectedAccountsSection = ({ socialAccounts = [] }) => {
  const hasAccounts = socialAccounts?.length > 0;
  const navigate = useNavigate();

  return (
    <div
      className='rounded-xl flex flex-col h-full p-6'
      style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
      }}
    >
      <div className='flex items-center justify-between mb-4'>
        <h3 className='font-bold text-sm' style={{ color: 'var(--text-primary)' }}>
          Connected Accounts
        </h3>
        <IconButton variant='ghostPrimary' icon={UserPlus} onClick={() => navigate('/socials')} />
      </div>

      {hasAccounts ? (
        <div className='space-y-3'>
          {socialAccounts.map((account) => (
            <div
              key={account.id}
              className='rounded-lg p-3 flex items-center justify-between'
              style={{
                background: 'var(--bg-surface)',
                border: '1px solid var(--border)',
              }}
            >
              <div className='flex items-center gap-3'>
                <div
                  className='w-8 h-8 rounded-full flex items-center justify-center overflow-hidden'
                  style={{ background: 'var(--bg-card-alt)', color: 'var(--text-muted)' }}
                >
                  {account.profile_photo ? (
                    <img
                      src={account.profile_photo}
                      alt='Profile'
                      className='w-full h-full object-cover'
                    />
                  ) : (
                    <Users className='w-4 h-4' />
                  )}
                </div>
                <div>
                  <div className='text-sm font-semibold truncate' style={{ color: 'var(--text-primary)' }}>
                    {account.username || account.pageName || account.platform}
                  </div>
                  <div className='text-[10px] capitalize' style={{ color: 'var(--text-muted)' }}>
                    {account.platform}
                    {account.account_type ? ` • ${account.account_type}` : ''}
                  </div>
                </div>
              </div>
              <span
                className='w-2 h-2 rounded-full'
                style={{
                  background: account.status === 'active' ? 'var(--brand)' : 'var(--text-ghost)',
                }}
              />
            </div>
          ))}
        </div>
      ) : (
        <div
          className='rounded-lg p-6 text-center'
          style={{
            background: 'var(--bg-surface)',
            border: '1px dashed var(--border)',
          }}
        >
          <Users className='w-10 h-10 mx-auto mb-3' style={{ color: 'var(--text-ghost)' }} />
          <p className='font-semibold text-sm' style={{ color: 'var(--text-body)' }}>
            No social accounts connected
          </p>
          <p className='text-xs mt-1' style={{ color: 'var(--text-muted)' }}>
            Connect your accounts to start posting
          </p>
        </div>
      )}
    </div>
  );
};

export default ConnectedAccountsSection;
